import { withInstall } from '../../../../utils/with-install'
import DefaultLayer from './DefaultLayer.vue'

export const ElAmapLayerDefault = withInstall(DefaultLayer)
export default ElAmapLayerDefault
